// Labels every team profile shares, French: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Informations personnelles',
    rows: {
      name: 'Nom',
      position: 'Fonction',
      birthdate: 'Date de naissance',
      nationality: 'Nationalité',
      maritalStatus: 'Situation familiale',
      location: 'Lieu',
      languages: 'Langues',
      programmingLanguages: 'Langages de programmation',
      certifications: 'Certifications',
      publications: 'Publications',
      links: 'Site web'
    }
  },
  education: {
    title: 'Formation'
  },
  skills: {
    title: 'Compétences spécialisées'
  },
  experience: {
    title: 'Projets et activités',
    techLabel: 'Technologies'
  },
  downloads: {
    title: 'Télécharger le profil',
    deLabel: 'Télécharger le profil en allemand',
    deDescription: 'PDF en allemand',
    enLabel: 'Télécharger le CV en anglais',
    enDescription: 'PDF en anglais'
  },
  cta: {
    title: 'Contact',
    button: 'Prendre contact'
  },
  pdf: {
    title: 'Profil',
    personalSection: 'Informations personnelles',
    educationSection: 'Formation',
    experienceSection: 'Projets et activités',
    skillsLabel: 'Compétences'
  }
};
